import React from 'react'
import { connect } from 'react-redux'

export const CMSSettings = (props) => {
  return (
    <div>CMSSettings</div>
  )
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(CMSSettings)